var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.stream)?_c('OpenViewStreamDialog',{attrs:{"stream":_vm.stream}},[_c('a',{staticClass:"icon-livenow live-on-sg"},[_vm._v(" Live Now on SG")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }